import React from 'react';

const MessageComponent = ({ message,msgType }) => {
  // Replace newlines with <br /> tags for HTML rendering
  const formattedMessage = message
    .replace(/\n\n/g, '<br /><br />') // Double line break
    .replace(/\n/g, '<br />');        // Single line break
    const className = msgType === 'received' ? 'received-message-text' : 'sent-message-text';
  return (
    <div
      dangerouslySetInnerHTML={{ __html: formattedMessage }}
      style={{ whiteSpace: 'pre-line' }} // Ensures that any additional spaces or line breaks are respected
      className={className}
    />
  );
};

export default MessageComponent;    